import { render, staticRenderFns } from "./pagodes-de-cos.vue?vue&type=template&id=885d7e50&scoped=true"
import script from "./pagodes-de-cos.vue?vue&type=script&lang=js"
export * from "./pagodes-de-cos.vue?vue&type=script&lang=js"
import style0 from "./pagodes-de-cos.vue?vue&type=style&index=0&id=885d7e50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "885d7e50",
  null
  
)

export default component.exports